import { notificationManagement } from "../../constants/actionTypes";

const ntfyMngmntGetRequest = (data, searchType) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_GET_REQUEST,
  data: data,
  searchType: searchType,
});

const ntfyMngmntGetSuccess = (data) => ({
  type: notificationManagement.NOTIFICATION_GET_MANAGEMENT_SUCCESS,
  data: data,
});

const ntfyMngmntGetError = (data) => ({
  type: notificationManagement.NOTIFICATION_MANGEMENT_GET_ERROR,
  data: data,
});

const ntfyMngmntCreateRequest = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_CREATE_REQUEST,
  data: data,
});

const ntfyMngmntCreateSuccess = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_CREATE_SUCCESS,
  data: data,
});

const ntfyMngmntCreateError = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_CREATE_ERROR,
  data: data,
});

const ntfyMngmntUpdateRequest = (id, formData) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_UPDATE_REQUEST,
  id: id,
  formData: formData,
});

const ntfyMngmntUpdateSuccess = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS,
  data: data,
});

const ntfyMngmntUpdateError = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_UPDATE_ERROR,
  data: data,
});

const myNtfyMngmntGetSuccess = (data) => ({
  type: notificationManagement.MY_NOTIFICATION_MANGEMENT_GET_SUCCESS,
  data: data,
});

const userNtfyMngmntGetSuccess = (data) => ({
  type: notificationManagement.USERS_NOTIFICATION_MANGEMENT_GET_SUCCESS,
  data: data,
});

const ntfyMngmntDeleteRequest = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_DELETE_REQUEST,
  data: data,
});

const ntfyMngmntDeleteSuccess = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_DELETE_SUCCESS,
  data: data,
});

const ntfyMngmntDeleteError = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_DELETE_ERROR,
  data: data,
});

const ntfyMngmntDefaultSuccess = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_DEFAULT_SUCCESS,
  data: data,
});

const ntfyMngmntSendRequest = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_SEND_REQUEST,
  data: data,
});

const ntfyMngmntSendSuccess = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_SEND_SUCCESS,
  data: data,
});

const ntfyMngmntSendError = (data) => ({
  type: notificationManagement.NOTIFICATION_MANAGEMENT_SEND_ERROR,
  data: data,
});

export {
  ntfyMngmntGetRequest,
  ntfyMngmntGetSuccess,
  ntfyMngmntCreateRequest,
  ntfyMngmntCreateSuccess,
  ntfyMngmntUpdateRequest,
  ntfyMngmntUpdateSuccess,
  ntfyMngmntGetError,
  ntfyMngmntCreateError,
  ntfyMngmntUpdateError,
  myNtfyMngmntGetSuccess,
  userNtfyMngmntGetSuccess,
  ntfyMngmntDeleteRequest,
  ntfyMngmntDeleteSuccess,
  ntfyMngmntDeleteError,
  ntfyMngmntDefaultSuccess,
  ntfyMngmntSendRequest,
  ntfyMngmntSendSuccess,
  ntfyMngmntSendError,
};
